import { render, staticRenderFns } from "./NavDrawerAccount.vue?vue&type=template&id=705c9bda&scoped=true"
import script from "./NavDrawerAccount.vue?vue&type=script&lang=ts"
export * from "./NavDrawerAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705c9bda",
  null
  
)

export default component.exports